import {
  ISalesItemOptionModel,
  SalesItemOptionModel,
} from './SalesItemOptionModel';
export interface IBussinesLineSalesItemOptionModel
  extends ISalesItemOptionModel {
  salesItemName: string;
  speciesId: number;
  traitId: number;
}

export class BusinessLineSalesItemOptionModel extends SalesItemOptionModel {
  salesItemName: string;
  speciesId: number;
  traitId: number;
  constructor(params: Partial<IBussinesLineSalesItemOptionModel>) {
    super(params);

    this.salesItemName = _.defaultTo(params.salesItemName, '');
    this.speciesId = _.defaultTo(params.speciesId, 0);
    this.traitId = _.defaultTo(params.traitId, 0);
  }
}
